<ng-container *transloco="let t;">
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{ t('Send Reminder to All text for heading (Documents Section Send Reminder modal) - Send Reminder to All') }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form>
        <div class="modal-body py-2">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12">
                    <div class="form-group">
                        <!-- <label for="phone">{{t("Phone (general) - Phone")}}</label> -->
                        <app-phone-input></app-phone-input>
                        <div class="d-flex justify-content-between align-items-center mt-25">
                            <small>khalid durani (Mobile):</small>
                            <small>karlsimplesign.io</small>
                        </div>
                    </div>
                    <p class="send-reminder-success-massage text-success mb-0">Reminder was sent on 04 Apr 2025 02:30 PM</p>
                </div>
            </div>
        </div>
        <div class="modal-footer px-1 border-top">
            <button type="button" class="btn btn-primary" rippleEffect>
                 {{ t('Send SMS text for button label (Documents Section Send Reminder modal) - Send SMS') }}
            </button>
            <button type="button" class="btn btn-primary" rippleEffect>
                {{ t('Send Email text for button label (Documents Section Send Reminder modal) - Send Email') }}
            </button>
            <button type="button" class="btn btn-primary" rippleEffect>
            {{ t('Send Email and SMS text for button label (Documents Section Send Reminder modal) - Send Email and SMS') }}
            </button>
        </div>
    </form>
</ng-container>